module.exports = __webpack_public_path__ + "media/src/images/icons/olympinfo/olympinfo-earth-27c4f13ac43fa740e8959d5951556bf5.svg";